module.exports = __webpack_public_path__ + "static/media/video.d840e932.png";